<script lang="ts" setup></script>

<template>
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g id="Tick Icon">
      <path
        id="Vector"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="white"
        stroke="#F40000"
        stroke-width="3"
      />
      <g id="Tick Icon_2">
        <path
          id="Vector_2"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          fill="white"
          stroke="white"
          stroke-width="3"
        />
        <path
          id="Vector_3"
          d="M8.00977 12.5L11.0097 15.5L16.0097 9.5"
          stroke="#F40000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </g>
    </g>
  </svg>
</template>

<style scoped></style>
